
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lth-solution/[slug]",
      function () {
        return require("private-next-pages/lth-solution/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lth-solution/[slug]"])
      });
    }
  